// frontend/src/components/LoadingSpinner.js
import React from 'react';


const LoadingSpinner = ({ size = 'md', text = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className="loading-spinner flex flex-col items-center justify-center gap-2">
      <div className={`spinner ${sizeClasses[size]}`} />
      {text && <span className="text-sm text-text-muted">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;